import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BalanceFrs, BalanceSheet } from '../../types';
import { accountsReportApi } from '../service';

export interface BalanceFrsState {
  values?: BalanceFrs;
}

const initialState: BalanceFrsState = {
  values: undefined,
};

export const balanceFrsSlice = createSlice({
  name: 'balanceFrs',
  initialState,
  reducers: {
    clearBalanceFrsState: (state) => {
      state.values = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      accountsReportApi.endpoints.getBalanceSheet.matchFulfilled,
      (
        state,
        action: PayloadAction<{ data: BalanceSheet }> & {
          meta: { fulfilledTimeStamp: number };
        },
      ) => {
        const { balanceSheetFRS } = action.payload.data;

        state.values = balanceSheetFRS;
      },
    );
  },
});

export const { clearBalanceFrsState } = balanceFrsSlice.actions;

export default balanceFrsSlice.reducer;
